import React, { Component } from 'react'
import { Main, MainTop, MainBody, MainTopTitle } from '@/components/Layout/Layout.Main'
import { WhiteBox } from '@/components/Layout/Layout.Box'
import Resx from '@/components/Resx'
import { DatePicker } from '@/components/DatePicker'
import { Form, FormGroup, Label, Col, Row, Input } from 'reactstrap'
import Icon from '@/components/Icon'
import { ButtonSection } from '@/components/Layout'
import { connect } from 'react-redux'
import { localized } from '@/decorators/localized'
import { actionCreators } from '@/store/usersManagement'
import context from '@/context'
import { ValidationBoundary, ValidationState, Validator, ServerValidator } from '@/components/validation'
import { DropDownList } from '@/components/dropDownList'
import validateUserEmail from '@/components/userManagement/validateUserEmail'
import { OrganizationalUnitSelector } from '@/components/organizationalUnitSelector'
import { IndividualSelector } from '@/components/individualSelector'

const mapStateToProps = (state) => {
  return {
    user: state.usersManagement.user,
    userCreating: state.usersManagement.userCreating,
    error: state.usersManagement.error
  }
}

const mapDispatchToProps = {
  updateDto: actionCreators.updateUserDto,
  createUser: actionCreators.createUser
}

@localized()
@connect(mapStateToProps, mapDispatchToProps)
class AddUser extends Component {
  constructor (props, context) {
    super(props, context)

    props.updateDto({ accountType: parseInt(this.props.match.params.type) })
  }

  onSaveClick = (e) => {
    e.preventDefault()
    this.props.createUser()
  }

  organizationUnitChanged = ({ value }) => {
    this.props.updateDto({
      organizationalUnitId: value,
      jobPositionAssignmentId: null
    })
  }

  onIndividualChange = ({ value }) => {
    this.props.updateDto({ individualId: value })
  }

  onJobPositionChange = ({ value }) => {
    this.props.updateDto({ jobPositionAssignmentId: value })
  }

  render () {
    const { updateDto, user, userCreating, error } = this.props
    const type = parseInt(this.props.match.params.type)
    return (
      <Main>
        <MainTop>
          <MainTopTitle backUrl='/users'>
            <Resx name='UsersManagement.Title' />
          </MainTopTitle>
        </MainTop>
        <MainBody clear>
          <Row>
            <Col className='col-md-3'>
              <WhiteBox>
                <ValidationBoundary serverError={error}>
                  <Form>
                    <FormGroup>
                      <Label><Resx name='UsersManagement.AccountEmail' /></Label>
                      <ServerValidator
                        name='email'
                        value={user.email || ''}
                        required
                        onValidate={({ value }) => validateUserEmail({ value })}
                        serverValidation={(email) => context.api.userManagementService.validateEmailIsUnique(email)}>
                        <Input value={user.email || ''} onChange={(e) => updateDto({ email: e.target.value })} />
                      </ServerValidator>
                    </FormGroup>
                    <FormGroup>
                      <Label><Resx name='UsersManagement.SelectIndividual' /></Label>
                      <Validator name='individual' value={user.individualId} required>
                        <IndividualSelector
                          dataSource={context.api.individualService.getIndividualsWithoutUserAccount}
                          onChange={this.onIndividualChange}
                          value={user.individualId}
                          onlyActive />
                      </Validator>
                    </FormGroup>
                    {type === 0 && user.individualId &&
                    <FormGroup>
                      <Label><Resx name='UsersManagement.SelectOrganizationalUnit' /></Label>
                      <Validator name='organizationalUnitId' value={user.organizationalUnitId} required>
                        <OrganizationalUnitSelector onChange={this.organizationUnitChanged} value={user.organizationalUnitId} />
                      </Validator>
                    </FormGroup>
                    }
                    {type === 0 && user.organizationalUnitId &&
                    <React.Fragment>
                      <FormGroup>
                        <Label><Resx name='UsersManagement.SelectJobPosition' /></Label>
                        <Validator name='jobPosition' value={user.jobPositionAssignmentId} required>
                          <DropDownList key={'organizationalUnit' + user.organizationalUnitId}
                            dataSource={ds => context.api.jobPositionService.getJobPositions(user.organizationalUnitId, ds)}
                            onChange={this.onJobPositionChange}
                            value={user.jobPositionAssignmentId} />
                        </Validator>
                      </FormGroup>
                      <FormGroup>
                        <Label><Resx name='UsersManagement.JobPositionValidFrom' /></Label>
                        <DatePicker value={user.validFrom} onChange={value => updateDto({ validFrom: value })} />
                      </FormGroup>
                      <FormGroup>
                        <Label><Resx name='UsersManagement.JobPositionValidTo' /></Label>
                        <DatePicker value={user.validTo} onChange={value => updateDto({ validTo: value })} />
                      </FormGroup>
                    </React.Fragment>
                    }
                    {type === 1 && user.individualId &&
                    <React.Fragment>
                      <FormGroup>
                        <Label><Resx name='UsersManagement.SelectInstitution' /></Label>
                        <DropDownList
                          dataSource={context.api.institutionService.getLookup}
                          onChange={({ value }) => updateDto({ institutionId: value })}
                          value={user.institutionId} />
                      </FormGroup>
                    </React.Fragment>
                    }
                    <ButtonSection className='mt-4'>
                      <ValidationState render={({ isValid, serverError }) =>
                        <React.Fragment>
                          {serverError && serverError.message &&
                          <span className='error'><Resx name={serverError.message} /></span>}
                          <button className='btn btn-success ml-auto' onClick={this.onSaveClick}
                            disabled={userCreating || !isValid}>
                            <Icon name={userCreating ? 'bx-loader bx-spin' : 'save'} />
                            <span><Resx name='Common.Save' /></span>
                          </button>
                        </React.Fragment>
                      } />
                    </ButtonSection>
                  </Form>
                </ValidationBoundary>
              </WhiteBox>
            </Col>
          </Row>
        </MainBody>
      </Main>
    )
  }
}

export default AddUser



// WEBPACK FOOTER //
// ./src/internal-app/pages/usersManagement/addUser.js